export const en = {
    common: {
        loading: 'Loading…',
        save: 'Save',
        cancel: 'Cancel',
        close: 'Close',
        edit: 'Edit',
        delete: 'Delete',
        confirm: 'Confirm',
        search: 'Search…',
        yes: 'Yes',
        no: 'No',
    },
    auth: {
        login: 'Sign in',
        logout: 'Sign out',
        email: 'Email address',
        password: 'Password',
        submit: 'Sign in',
        tagline: 'Municipal territorial intelligence platform',
        forgotPassword: 'Forgot your password?',
        welcome: 'Welcome',
        welcomeBack: 'Welcome back',
    },
    dashboard: {
        title: 'Dashboard',
        selectCity: 'Choose a city',
        selectCityDescription: 'Select the municipality you want to view.',
        noReports: 'No reports',
        noReportsDescription: 'No reports have been created for this city.',
    },
    reports: {
        title: 'Reports',
        new: 'New report',
        reference: 'Reference',
        priority: 'Priority',
        status: 'Status',
        category: 'Category',
        types: 'Problem types',
        createdAt: 'Created at',
        resolvedAt: 'Resolved at',
        assignedTo: 'Assigned to',
        unassigned: 'Unassigned',
    },
};
//# sourceMappingURL=en.js.map